import { MethodTypeRepository } from '@telespot/protocols/domain';

export interface FindMethodTypeForSampleAcquisitionField {
  displayName: string;
  fieldPath: string;
}

export interface FindMethodTypeForSamplePipeline {
  pipeline: string;
  configId: string;
}

export interface FindMethodTypeForSampleLabelConfig {
  label: string;
  configId: string;
  color: string;
}

export interface FindMethodTypeForSampleOutput {
  id: string;
  pipelineIds: Record<string, FindMethodTypeForSamplePipeline>;
  labelConfig: Record<string, FindMethodTypeForSampleLabelConfig>;
  acquisitionFields: FindMethodTypeForSampleAcquisitionField[];
}

export interface IFindMethodTypeForSampleQuery {
  /**
   * Resolves the method type associated with the given sample.
   * @returns The method type's id, pipeline references, label color/threshold
   *   config, and acquisition field metadata. `undefined` if the sample has no
   *   method type or the lookup fails.
   */
  execute(sampleId: string): Promise<FindMethodTypeForSampleOutput | undefined>;
}

export class FindMethodTypeForSampleQuery implements IFindMethodTypeForSampleQuery {
  constructor(private readonly methodTypeRepository: MethodTypeRepository) {}

  public async execute(sampleId: string): Promise<FindMethodTypeForSampleOutput | undefined> {
    try {
      const methodType = await this.methodTypeRepository.findForSample(sampleId);
      if (!methodType) return undefined;
      return {
        id: methodType.id,
        pipelineIds: methodType.pipelineIds,
        labelConfig: methodType.labelConfig,
        acquisitionFields: methodType.acquisitionFields,
      };
    } catch (error) {
      console.error('Error finding method type for sample:', error);
      return undefined;
    }
  }
}
